import { Injectable } from '@angular/core'
import { JWTTokenService } from '../jwt-token'
import { SignOutCommand } from './sign-out.command'

@Injectable()
export class SignOutService {
  constructor(
    private signOutCommand: SignOutCommand,
    private jwtTokenService: JWTTokenService
  ) {}

  signOut(): void {
    this.signOutCommand.call().subscribe(() => {
      this.jwtTokenService.remove()
      window.location.href = '/identities/signin'
    })
  }
}
